import React, { useState, Fragment } from 'react';

import { Modal, Header, Body, Footer, FooterButton } from '../modalElements';
import { RadioButtonMark } from 'components/Checkbox/Checkbox';
import { ModalContent } from '../styles';
import {
  TestNameLabel,
  OptionsContainer,
  OptionAndLabelContainer,
  Question,
  OptionLabel,
  CommentTextArea,
} from './styles';

export const FeedbackForm = [
  {
    question: 'How was your overall experience taking this test?',
    options: ['Poor', 'Fair', 'Good', 'Very Good'],
  },
  {
    question: 'Did you feel that you had enough time to finish the test?',
    options: ['Not Enough', 'Precisely timed', 'Sufficient', 'Plentiful'],
  },
  {
    question: 'How was the difficulty of the test in relation to the job position?',
    options: ['Difficult', 'Slightly difficult', 'Average', 'Easy'],
  },
];

export default React.memo((props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [feedbackForm, setFeedbackForm] = useState([
    {
      question: FeedbackForm[0].question,
      review: '',
    },
    {
      question: FeedbackForm[1].question,
      review: '',
    },
    {
      question: FeedbackForm[2].question,
      review: '',
    },
    {
      comment: '',
    },
  ]);

  const submitForm = (value) => {
    setIsOpen(true);
    return props.confirm(feedbackForm, value);
  };

  return (
    <Modal isOpen={isOpen}>
      <Header>We value your feedback!</Header>
      <Body>
        <ModalContent>
          <TestNameLabel>{props.test}</TestNameLabel>
          <br />
          {FeedbackForm.map((feedback, index) => {
            return (
              <Fragment key={index}>
                <Question>{feedback.question}</Question>
                <OptionsContainer>
                  {feedback.options.map((option, optionIndex) => {
                    return (
                      <OptionAndLabelContainer
                        key={optionIndex}
                        onClick={() =>
                          setFeedbackForm((form) =>
                            Object.assign([...form], { [index]: { ...form[index], review: option } })
                          )
                        }
                      >
                        <RadioButtonMark checked={feedbackForm[index]['review'] === option} />
                        <OptionLabel>{option}</OptionLabel>
                      </OptionAndLabelContainer>
                    );
                  })}
                </OptionsContainer>
              </Fragment>
            );
          })}
          <Question>Additional feedback:</Question>
          <CommentTextArea
            rows="4"
            placeholder="Write any additional feedback here"
            onChange={(e) => setFeedbackForm((form) => Object.assign([...form], { 3: { comment: e.target.value } }))}
          ></CommentTextArea>
        </ModalContent>
      </Body>
      <Footer>
        <FooterButton label="Close" onClick={() => submitForm(false)} autoFocus />
        <FooterButton label="Submit" onClick={() => submitForm(true)} />
      </Footer>
    </Modal>
  );
});
